import React, { createContext, useState } from 'react';

// TODO if not used, remove everywhere

const UserContext = createContext();

const UserStoreProvider = props => {
  const [me, setMe] = useState(null);
  const [initialLoadDone, setInitialLoadDone] = useState(false);

  return (
    <UserContext.Provider value={{ me, setMe, initialLoadDone, setInitialLoadDone }} {...props} />
  );
};

export { UserStoreProvider, UserContext };
